import { groupBy } from 'es-toolkit';
import React from 'react';
import { Stack } from '@mui/material';
import { matchSorter } from 'match-sorter';

import { Station } from '@paragon/contract-library';
import { sortBy } from '@paragon/utilities';

import { useAppSelector } from '../hooks';
import { StationCard } from './cards/StationCard';

const MULTIPLE_LINES = Symbol('multiple');

export function AllStationsList(props: { filter?: string }) {
  const linesState = useAppSelector((state) => state.lines);
  const stationsState = useAppSelector((state) => state.stations);

  if (linesState.status !== 'loaded' || stationsState.status !== 'loaded') {
    return null;
  }

  const allStationsForDisplay: { lineGuid?: string | typeof MULTIPLE_LINES; station: Station }[] = [];

  const stationsOnLines: { lineGuid?: string; station: Station }[] = [];
  const guidsOfStationsNotOnLines = new Set(Object.keys(stationsState.stations));

  for (const [lineGuid, stationsInLine] of Object.entries(linesState.stationInsertions)) {
    for (const stationInsertion of stationsInLine) {
      guidsOfStationsNotOnLines.delete(stationInsertion.guid);
      stationsOnLines.push({ lineGuid, station: stationsState.stations[stationInsertion.guid] });
    }
  }

  for (const groupedStationsOnLines of Object.values(groupBy(stationsOnLines, (bundle) => bundle.station.guid))) {
    if (groupedStationsOnLines.length === 1) {
      allStationsForDisplay.push(groupedStationsOnLines[0]);
    } else {
      allStationsForDisplay.push({ lineGuid: MULTIPLE_LINES, station: groupedStationsOnLines[0].station });
    }
  }

  for (const topLevelStationGuid of guidsOfStationsNotOnLines) {
    allStationsForDisplay.push({ station: stationsState.stations[topLevelStationGuid] });
  }

  let sortedStationsForDisplay = sortBy(allStationsForDisplay, ({ station }) => station.name);

  if (props.filter) {
    sortedStationsForDisplay = matchSorter(allStationsForDisplay, props.filter, { keys: ['station.name'] });
  }

  const cards = sortedStationsForDisplay.map(({ station, lineGuid }) => (
    <StationCard
      key={station.guid}
      station={station}
      onMultipleLines={lineGuid === MULTIPLE_LINES}
      lineGuid={lineGuid === MULTIPLE_LINES ? undefined : lineGuid}
    />
  ));

  return <Stack spacing={1}>{cards}</Stack>;
}
